import React, { useEffect, useState } from 'react'
import { Modal, Button, Form, Input, message, DatePicker, Row, Col, Select, ConfigProvider } from 'antd';
import 'antd/dist/antd.css';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import axios from 'axios';
import api from '../../../services/api';
import * as ModalStatusAction from '../../../redux/actions/modalStatus'
import locale from 'antd/lib/locale/pt_BR';
import moment from 'moment';
import  MaskedInput  from 'react-input-mask';
import { municipioService } from '../../../services/Municipios-Service/municipios-service';
import { loginService } from '../../../services/Login-Service/login-service';

interface ModalEditarFeriadoProps {
    modalStatus?: any,
    setEditarFeriadoModal?: any
}

const ModalEditarFeriado: React.FC<ModalEditarFeriadoProps> = (prop) => {

    let visible = prop.modalStatus[0].visibleEditarFeriado
    const [form] = Form.useForm();
    const [ehTipoMunicipal, setEhTipoMunicipal] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);
    const { Option } = Select;
    const [municipios, setMunicipios] = useState<any>();
    const { TextArea } = Input;
    let tipoFeriados: any[] = [];
    const [tipoFeriadoInput, setTipoFeriadoInput] = useState<any[]>();

    useEffect(() => {
        municipioService.getMunicipio().then((resp)=>{
            setMunicipios(resp.data)
        })
        api.get(`Feriado/gettipoferiado`).then((response) => {
            tipoFeriados = response.data;
            setTipoFeriadoInput(tipoFeriados)
        })
        form.resetFields();
        if (prop.modalStatus[0].feriado != null) {
            let dataInicio = new Date(Date.parse(moment(prop.modalStatus[0].feriado.dataInicio, 'DD/MM/YYYY').toLocaleString())).toLocaleDateString();
            form.setFieldsValue({ feriadoID: prop.modalStatus[0].feriado.feriadoID })
            form.setFieldsValue({ dataInicio: prop.modalStatus[0].feriado.dataInicio ?
                dataInicio : null,
            })
            form.setFieldsValue({ nome: prop.modalStatus[0].feriado.nome })
            form.setFieldsValue({ descricao: prop.modalStatus[0].feriado.descricao })
            form.setFieldsValue({ tipo: prop.modalStatus[0].feriado.tipo })
            form.setFieldsValue({ fixo: prop.modalStatus[0].feriado.fixo })
            if(prop.modalStatus[0].feriado.tipo == "MUNICIPAL"){
                setEhTipoMunicipal("Municipal")
                form.setFieldsValue({municipioID: prop.modalStatus[0].feriado.municipioID})                
            }
            else{
                setEhTipoMunicipal("")
            }
        }
    }, [visible])

    const handleCancel = () => {
        prop.setEditarFeriadoModal(false)
    };

    function toISOFormat(dateTimeString: string) {
        // Primeiro, dividimos a data completa em duas partes:
        const [DD, MM, YYYY] = dateTimeString.split('/');
        // Retornamos a data formatada em um padrão compatível com ISO:
        return `${YYYY}-${MM}-${DD}`;
    }

    const validarData = (_: any, value: { number: number }) => {
        if (form.getFieldValue("dataInicio") != undefined) {
            let result, data;
            let dataFormatada = toISOFormat(form.getFieldValue("dataInicio"));
            data = new Date(dataFormatada);
            result = moment(data).isValid();
            if (result == false) {
                return Promise.reject(new Error('Data inválida!'));
            }
            return Promise.resolve();
        }
        return Promise.resolve();
    };

    const onFinish = (values: any) => {
        setLoading(true);
        let dataInicio;

        if (values.dataInicio != undefined) {
            let dataFormatada = toISOFormat(values.dataInicio);
            dataInicio = new Date(dataFormatada);
        }
        if(values.tipo == "Nacional" || values.tipo == "Estadual"){
            values.municipiodID = null;
        }
        api.put(`Feriado`, {
            FeriadoID: values.feriadoID,
            Nome: values.nome,
            Descricao: values.descricao,
            DataInicio: dataInicio,
            Tipo: values.tipo,
            Fixo: values.fixo == "true" ? true : false,
            Ativo: true,
            MunicipioID: values.municipioID
        })
            .then((response) => {
                if (response.data.valido) {
                    message.success('Feriado editado com Sucesso')
                    prop.setEditarFeriadoModal(false);
                }
                else {
                    message.error(response.data.error)
                }
            })
            .catch((err) => {
                message.error('Falha na requisição')
            })
            .finally(() => {
                setLoading(false);
            })
    };

    const handleOption = (value:any)=>{
        setEhTipoMunicipal(value)
    }

    return (
        <Modal
            visible={visible}
            title="Editar Feriado"
            onCancel={handleCancel}
            footer={null}
        >
            <Form
                name="basic"
                form={form}
                onFinish={onFinish}
            >
                <Form.Item
                    label="FeriadoID"
                    name="feriadoID"
                    hidden={true}
                >
                    <Input type="number" hidden={true} />

                </Form.Item>

                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={24}>
                        <Form.Item
                            label="Nome"
                            name="nome"
                            rules={[
                                {
                                    required: true,
                                    message: 'Obrigatório!',
                                }
                            ]}
                        >
                            <Input placeholder="Digite o Nome do Feriado" />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={24}>
                        <Form.Item
                            label="Descrição"
                            name="descricao"
                            rules={[
                                {
                                    required: true,
                                    message: 'Obrigatório!',
                                }
                            ]}
                        >
                            <TextArea maxLength={250} rows={4}></TextArea>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={12}>
                        <Form.Item
                            label="Data"
                            name="dataInicio"
                            rules={[
                                {
                                    required: true,
                                    message: 'Obrigatório!',
                                    validator: validarData
                                }
                            ]}
                        >
                            <MaskedInput className="ant-input" placeholder="Informe a Data" mask="99/99/9999" />
                            {/* <DatePicker placeholder="Informe a Data do Feriado" format="DD/MM/YYYY" /> */}
                        </Form.Item>
                    </Col>
                    <Col className="gutter-row" span={12}>
                        <Form.Item
                            label="Fixo"
                            name="fixo"
                            rules={[
                                {
                                    required: true,
                                    message: 'Obrigatório!',
                                }
                            ]}
                        >
                            <Select placeholder="Fixo">
                                <Option value="true">Sim</Option>
                                <Option value="false">Não</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={24}>
                        <Form.Item
                            label="Tipo"
                            name="tipo"
                            rules={[
                                {
                                    required: true,
                                    message: 'Obrigatório!',
                                }
                            ]}
                        >
                            <Select onChange={handleOption} placeholder="Tipo">
                                {tipoFeriadoInput?.map(tipo => (
                                    <Option value={tipo.enum}>{tipo.enum}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>

                </Row>
                {ehTipoMunicipal == "Municipal"? 
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={24}>
                        <Form.Item
                            label="Município"
                            name="municipioID"
                            rules={[
                                {
                                    required: true,
                                    message: 'Por favor selecione!',
                                }
                            ]}
                        >
                            <Select placeholder="Informe o município do feriado">
                                {loginService.ehTecnicoMunicipal(sessionStorage.getItem('grupoID') || "") ? 
                                    <>
                                    <Select.Option  value={municipios.municipioID}>{municipios.nome}</Select.Option>
                                    </>                                    
                                :
                                 municipios?.map((value:any, index:number)=>
                                    <Select.Option key={index} value={value.municipioID}>{value.nome}</Select.Option>
                                    )
                                }
                            </Select>
                        </Form.Item>
                    </Col>

                </Row>
                :null}

                <Form.Item>
                    <Button className="button-pre-cadastro" type="primary" htmlType="submit">
                        Editar
                    </Button>
                </Form.Item>
            </Form>
        </Modal >
    );
}

const mapStateToProps = (state: any) => ({
    modalStatus: state.modalStatus,
})

const mapDispatcToProps = (dispatch: any) => bindActionCreators(ModalStatusAction, dispatch)

export default connect(mapStateToProps, mapDispatcToProps)(ModalEditarFeriado);